import { lazy, Suspense } from 'react';
import useDevice from '../hooks/useDevice';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Section1 from 'components/ECommerce/Section1';
import Section2 from 'components/ECommerce/Section2';
import Section3 from 'components/ECommerce/Section3';
import Section4 from 'components/ECommerce/Section4';
import Section5 from 'components/ECommerce/Section5';
import Section6 from 'components/ECommerce/Section6';
import Section7 from 'components/ECommerce/Section7';
import Section8 from 'components/ECommerce/Section8';
import Section9 from 'components/ECommerce/Section9';
import Section10 from 'components/ECommerce/Section10';
import { Box } from '@mui/material';
import FloatingSection from 'components/ECommerce/FlotingSection';
import { E_COMMERCE_STYLES } from 'components/ECommerce/config';

const ContactSection = lazy(() => import('../components/ContactUs/ContactSection'));
const DefaultNavbar = lazy(() => import('../components/DefaultNavbar'));
const MetaData = lazy(() => import('../MetaData'));

function ECommerceGCC() {
  const { isMobile } = useDevice();

  const PreLoad = (
    <div className="h-screen w-100 flex items-center justify-center bg-black">
      {/* <h3 className="text-osperb-blue">Osperb</h3> */}
    </div>
  );

  return (
    <>
      <MetaData
        title={'Portfolio'}
        content={
          'At osperb, our team has equipped with a visionary agenda on making human life and activities easier.'
        }
        keyword={
          'website, app, software, website malappuram, internship, UAE, OMAN, CANADA, ERP, CRM, CMS, FMS, factory management system, mahal management system, institute management system, disgning, branding, digital markerting social media'
        }
      />
      <Suspense fallback={PreLoad}>
        <DefaultNavbar isDark />
      </Suspense>

      {isMobile ? (
        <Box
          sx={{ position: 'relative' }}
          maxWidth={E_COMMERCE_STYLES.container.maxWidthTablet}
          margin={E_COMMERCE_STYLES.container.mx}
        >
          <Section1 />
          <Section2 />
          <Section3 />
          <Section4 />
          <Section5 />
          <Section6 />
          <Section7 />
          <Section8 />
          <Section9 />
          <Section10 />
        </Box>
      ) : (
        <></>
      )}
      <FloatingSection />
      <Suspense fallback={PreLoad}>
        <ContactSection />
      </Suspense>
    </>
  );
}

export default ECommerceGCC;
